import React, { Component } from "react";
import firebase from "../../utils/firebase";

import { FormSection, Field, FormFooter } from "@atlaskit/form";
import FieldTextStateless from "@atlaskit/field-text";
import Button from "@atlaskit/button";

import "./profileFormEmploymentAdd.css";

const initState = {
  employer: "",
  position: "",
  employmentLength: "",
  supervisor: "",
  businessPhone: "",
  businessAddress: "",
  monthlySalary: ""
};

const initError = {
  employerError: false,
  positionError: false,
  employmentLengthError: false,
  supervisorError: false,
  businessPhoneError: false,
  businessAddressError: false,
  monthlySalaryError: false
};
export default class ProfileFormEmploymentAdd extends Component {
  constructor(props) {
    super(props);

    this.state = { ...initState, ...initError };
  }

  fieldTextHandler = e =>
    this.setState({ [`${e.target.name}`]: e.target.value, ...initError });

  validate = () => {
    const {
      employer,
      position,
      employmentLength,
      supervisor,
      businessPhone,
      businessAddress,
      monthlySalary
    } = this.state;
    if (employer.length === 0) return this.setState({ employerError: true });
    else if (position.length === 0)
      return this.setState({ positionError: true });
    else if (employmentLength.length === 0)
      return this.setState({ employmentLengthError: true });
    else if (supervisor.length === 0)
      return this.setState({ supervisorError: true });
    else if (businessAddress.length === 0)
      return this.setState({ businessAddressError: true });
    else if (businessPhone.length === 0)
      return this.setState({ businessPhoneError: true });
    else if (
      this.props.type.toLowerCase() === "current" &&
      monthlySalary.length === 0
    )
      return this.setState({ monthlySalaryError: true });
    else this.save();
  };

  save = () => {
    const {
      employer,
      position,
      employmentLength,
      supervisor,
      businessPhone,
      businessAddress,
      monthlySalary
    } = this.state;
    const updateObj = {
      employer,
      position,
      employmentLength,
      supervisor,
      businessPhone,
      businessAddress
    };
    if (this.props.type.toLowerCase() === "current") {
      updateObj.monthlySalary = monthlySalary;
    }
    firebase
      .firestore()
      .collection("my")
      .doc(this.props.userContext.user.uid)
      .update({
        [`${this.props.type.toLowerCase()}Employment`]: updateObj
      })
      .then(() => console.log("success"))
      .catch(error => console.log(error));
  };

  render() {
    return (
      <div className="profile-form__employment-unit">
        <FormSection>
          <Field
            label={`${this.props.type} Employer`}
            isRequired
            isInvalid={this.state.employerError}
          >
            <FieldTextStateless
              onChange={this.fieldTextHandler}
              value={this.state.employer}
              name="employer"
              isRequired
              shouldFitContainer
            />
          </Field>
          <Field
            label="Position"
            isRequired
            isInvalid={this.state.positionError}
          >
            <FieldTextStateless
              onChange={this.fieldTextHandler}
              value={this.state.position}
              name="position"
              isRequired
              shouldFitContainer
            />
          </Field>
          <Field
            label="Length of Employment"
            isRequired
            isInvalid={this.state.employmentLengthError}
          >
            <FieldTextStateless
              onChange={this.fieldTextHandler}
              value={this.state.employmentLength}
              name="employmentLength"
              isRequired
              shouldFitContainer
            />
          </Field>
          <Field
            label="Supervisor"
            isRequired
            isInvalid={this.state.supervisorError}
          >
            <FieldTextStateless
              onChange={this.fieldTextHandler}
              value={this.state.supervisor}
              name="supervisor"
              isRequired
              shouldFitContainer
            />
          </Field>
          <Field
            label="Business Address"
            isRequired
            isInvalid={this.state.businessAddressError}
          >
            <FieldTextStateless
              onChange={this.fieldTextHandler}
              value={this.state.businessAddress}
              name="businessAddress"
              isRequired
              shouldFitContainer
            />
          </Field>
          <Field
            label="Business Telephone"
            isRequired
            isInvalid={this.state.businessPhoneError}
          >
            <FieldTextStateless
              onChange={this.fieldTextHandler}
              value={this.state.businessPhone}
              name="businessPhone"
              isRequired
              shouldFitContainer
            />
          </Field>
          <Field
            label="Monthly Salary Range"
            isRequired={this.props.type.toLowerCase() === "current"}
            disabled={this.props.type.toLowerCase() === "previous"}
            isInvalid={this.state.monthlySalaryError}
          >
            <FieldTextStateless
              onChange={this.fieldTextHandler}
              value={this.state.monthlySalary}
              name="monthlySalary"
              isRequired={this.props.type.toLowerCase() === "current"}
              disabled={this.props.type.toLowerCase() === "previous"}
              shouldFitContainer
            />
          </Field>
        </FormSection>

        <FormFooter>
          <Button
            className="profile-form-employment-add__button"
            onClick={this.validate}
            appearance="primary"
            type="submit"
          >
            Save
          </Button>
        </FormFooter>
      </div>
    );
  }
}

ProfileFormEmploymentAdd.defaultProps = {
  userContext: {
    user: {},
    my: {}
  },
  type: ""
};



// WEBPACK FOOTER //
// ./src/components/profileFormEmploymentAdd/ProfileFormEmploymentAdd.js